










































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import BaseSuketCard from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketCard.vue";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import BaseSuketTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/BaseSuketTabPage";

import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { getAge, formatDMYDate } from "@/utility/DateUtils";
import { storeDokter } from "@/store/modules/dokter";

import moment from "moment";
import SuketFitToWork from "@/store/modules/SuketFitToWork";
import {
  SuketBaseWithRelationship,
  SuketFitToWorkInterface
} from "@/types/common_surat_keterangan";
import { storeUnit } from "@/store/modules/unit";
import PDFViewer from "@/components/PDFViewer.vue";

@Component({
  components: {
    CardModalTtd,
    BaseSuketCard,
    PDFViewer
  }
})
export default class SuketFitToWorkTabPage extends BaseSuketTabPage {
  @Prop() declare readonly register: string | number;

  allowedUnit = ["*"];
  suketSvc = new CommonSuket(EnSuketCategory.FitToWork);
  suketStore = SuketFitToWork;

  get pdfUrl() {
    return this.dataSuket
      ? this.getSuketPdfUrl(EnSuketCategory.FitToWork, this.dataSuket.id)
      : null;
  }

  register_id = this.register;
  pasien_rm = this.pasien.rm;
  unit_id = this.user.unit_id;
  nama = this.pasien.nama;
  umur = getAge(formatDMYDate(this.pasien.tgl_lahir))
    .toString()
    .concat(" Th");

  surat_date = moment().format("YYYY-MM-DD");
  signee_user_id = this.user.id;
  creator_user_id = this.user.id;
  alamat_type = "ktp";

  today = moment().format("YYYY-MM-DD");
  klinik = null;
  tglPemeriksaan = moment().format("YYYY-MM-DD");
  pemeriksaan: Array<{
    id: string;
    name: string;
    result: string;
  }> = [
    {
      id: "ekg",
      name: "EKG",
      result: null
    },
    {
      id: "treadmill",
      name: "Treadmill",
      result: null
    }
  ];
  kesimpulan = null;
  tglPemeriksaanShow = false;
  suratDateShow = false;

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  modalTtdSkJiwa = false;
  saving = false;
  loadedRatio = 0;

  mounted() {
    this.register_id = this.dataSuket?.register_id || this.register;
    this.pasien_rm = this.dataSuket?.pasien_rm || this.pasien.rm;
    this.unit_id = this.dataSuket?.unit_id || this.user.unit_id;
    this.nama = this.pasien.nama;
    this.umur =
      this.dataSuket?.pasien.umur_th ||
      getAge(formatDMYDate(this.pasien.tgl_lahir))
        .toString()
        .concat(" Th");

    this.surat_date = this.dataSuket?.surat_date || this.today;
    this.signee_user_id = this.dataSuket?.signee_user_id || this.user.id;
    this.creator_user_id = this.dataSuket?.creator_user_id || this.user.id;
    this.alamat_type = this.dataSuket?.content.alamat_type;

    this.klinik = this.dataSuket?.content?.klinik;
    this.tglPemeriksaan =
      this.dataSuket?.content?.pemeriksaan_date || this.today;
    this.tglPemeriksaanShow = false;
    this.pemeriksaan = this.dataSuket?.content?.pemeriksaan || this.pemeriksaan;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get alamatOptions() {
    const opts = [
      {
        id: "ktp",
        name: this.pasien.alamat,
        category: "Alamat KTP"
      }
    ];

    if (this.pasien.alamat_domisili) {
      opts.push({
        id: "domisili",
        name: this.pasien.alamat_domisili,
        category: "Alamat Domisili"
      });
    }

    return opts;
  }

  get user() {
    return userModule.user;
  }

  get input() {
    return {
      register_id: this.register_id,
      pasien_rm: this.pasien_rm,
      unit_id: this.unit_id,
      content: {
        alamat_type: this.alamat_type,
        klinik: this.klinik,
        pemeriksaan_date: this.tglPemeriksaan,
        pemeriksaan: this.pemeriksaan,
        kesimpulan: this.kesimpulan
      },
      surat_date: this.surat_date,
      signee_user_id: this.signee_user_id,
      creator_user_id: this.creator_user_id
    };
  }

  get listDokter() {
    return storeDokter.list;
  }

  get listKlinik() {
    return storeUnit.unitPagi.map(item => {
      return {
        id: item.id,
        name: item.nama
      };
    });
  }

  get canSign() {
    return this.user.id == this.signee_user_id;
  }

  save() {
    if (!this.saving) {
      this.saving = true;

      const action = this.dataSuket
        ? this.suketSvc.update(this.dataSuket.id, this.input)
        : this.suketSvc.create(this.input);

      action
        .then(() => {
          if (this.canSign) {
            this.showSignatureModal();
          }

          appModule.NoticeDelay("Berhasil Simpan");

          this.close();
          this.suketStore.getSuketByRegister(this.register);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.expandInput = false;
  }

  tglPemeriksaanFormat() {
    return this.tglPemeriksaan
      ? moment(this.tglPemeriksaan, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  suratDateFormat() {
    return this.surat_date
      ? moment(this.surat_date, "YYYY-MM-DD").format("DD MMMM YYYY")
      : "";
  }

  @Watch("dataSuket")
  changeDataSuket(val: SuketBaseWithRelationship<SuketFitToWorkInterface>) {
    if (val) {
      this.register_id = val.register_id;
      this.pasien_rm = val.pasien_rm.toString();
      this.unit_id = val.unit_id;
      this.nama = val.pasien.nama;
      this.umur = val.pasien.umur_th;
      this.surat_date = val.surat_date;
      this.signee_user_id = val.signee_user_id;
      this.creator_user_id = val.creator_user_id;
      this.alamat_type = val.content.alamat_type;
      this.klinik = val.content?.klinik;
      this.tglPemeriksaan = val.content?.pemeriksaan_date;
      this.pemeriksaan = val.content?.pemeriksaan;
      this.kesimpulan = val.content?.kesimpulan;
    } else {
      this.register_id = this.register;
      this.pasien_rm = this.pasien.rm;
      this.unit_id = this.user.unit_id;
      this.nama = this.pasien.nama;
      this.umur = getAge(formatDMYDate(this.pasien.tgl_lahir))
        .toString()
        .concat(" Th");
      this.surat_date = moment().format("YYYY-MM-DD");
      this.signee_user_id = this.user.id;
      this.creator_user_id = this.user.id;
      this.alamat_type = "ktp";
      this.klinik = null;
      this.tglPemeriksaan = moment().format("YYYY-MM-DD");
      this.pemeriksaan = null;
      this.kesimpulan = null;
    }
  }
}
